import { useSnapshot } from "valtio";
import { myactionsstore } from "./store-myactions";
import { configStore } from "../state/CommonState";
import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import MonApi from "../state/mongo-api";
import {SHIPMENT_TYPE, SHIPMENT_SCOPE} from '../util/constants'
import Api from "../state/Api";
import { BsFillEyeFill } from "react-icons/bs";
import { MdDelete, MdEdit } from "react-icons/md";
import Utils from "../util/Utils"
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QUILL_MODULES = { toolbar: false };

export function ExceptionModal(props){
    useSnapshot(myactionsstore);
    useSnapshot(configStore);
    let ret = configStore.modalvisibledata;
    let status = [{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed" }]
    let mileStoneArr = []
    let destination = ret?.destination2 ? 'Multiple' : 'Destination'
    if(ret.shipmentType !== SHIPMENT_TYPE.air){
        if(ret.shipmentScope === SHIPMENT_SCOPE.d2p || ret.shipmentScope === SHIPMENT_SCOPE.d2d){
            mileStoneArr.push({ value: "Origin", label: "Origin" })
        }
        if(ret.por === ret.pol){
            mileStoneArr.push({ value: "pol_location", label: "POL" })
        }else{
            mileStoneArr.push({ value: "por_location", label: "POR" })
            mileStoneArr.push({ value: "pol_location", label: "POL" })
        }
        if(ret.pod === ret.fpod){
            mileStoneArr.push({ value: "fpod_location", label: "FPOD" })
        }else{
            mileStoneArr.push({ value: "pod_location", label: "POD" })
            mileStoneArr.push({ value: "fpod_location", label: "FPOD" })
        }
        if(ret.shipmentScope === SHIPMENT_SCOPE.p2d || ret.shipmentScope === SHIPMENT_SCOPE.d2d){
            mileStoneArr.push({ value: "destination", label: "Destination" })
        }
    }
    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p && ret.por === ret.pol){
    //     mileStoneArr = [
    //         { value: "pol_location", label: "POL" },
    //         // { value: "fpod_location", label: "FPOD" },
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p && ret.por !== ret.pol){
    //     mileStoneArr = [
    //         { value: "por_location", label: "POR" },
    //         { value: "pol_location", label: "POL" },
    //         { value: "pod_location", label: "POD" },
    //         // { value: "fpod_location", label: "FPOD" },
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d && ret.por === ret.pol){
    //     mileStoneArr = [
    //         { value: "pol_location", label: "POL" },
    //         { value: "fpod_location", label: "FPOD" },
    //         // { value: destination, label: destination }
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d  && ret.por !== ret.pol){
    //     mileStoneArr = [
    //         { value: "por_location", label: "POR" },
    //         { value: "pol_location", label: "POL" },
    //         { value: "pod_location", label: "POD" },
    //         { value: "fpod_location", label: "FPOD" },
    //         // { value: destination, label: destination }
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d && ret.por === ret.pol){
    //     mileStoneArr = [
    //         { value: "Origin", label: "Origin" },
    //         { value: "pol_location", label: "POL" },
    //         { value: "fpod_location", label: "FPOD" },
    //         // { value: destination, label: destination }
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d && ret.por !== ret.pol){
    //     mileStoneArr = [
    //         { value: "Origin", label: "Origin" },
    //         { value: "por_location", label: "POR" },
    //         { value: "pol_location", label: "POL" },
    //         { value: "pod_location", label: "POD" },
    //         { value: "fpod_location", label: "FPOD" },
    //         // { value: destination, label: destination }
    //         ];
    // }

    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p && ret.por === ret.pol){
    //     mileStoneArr = [
    //         { value: "Origin", label: "Origin" },
    //         { value: "pol_location", label: "POL" },
    //         // { value: "fpod_location", label: "FPOD" },
    //         ];
    // }
    // if(ret.shipmentType !== SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p && ret.por !== ret.pol){
    //     mileStoneArr = [
    //         { value: "Origin", label: "Origin" },
    //         { value: "por_location", label: "POR" },
    //         { value: "pol_location", label: "POL" },
    //         { value: "pod_location", label: "POD" },
    //         // { value: "fpod_location", label: "FPOD" },
    //         ];
    // }

    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2p){
        mileStoneArr = [
            { value: "departure_airport_location", label: "AOD" },
            ];
    }

    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.p2d){
        mileStoneArr = [
            { value: "departure_airport_location", label: "AOD" },
            { value: "arrival_airport_location", label: "AOA" },
            { value: "destination", label: "Destination" }
            ];
    }
    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2p){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "departure_airport_location", label: "AOD" },
            ];
    }
    if(ret.shipmentType == SHIPMENT_TYPE.air && ret.shipmentScope === SHIPMENT_SCOPE.d2d){
        mileStoneArr = [
            { value: "Origin", label: "Origin" },
            { value: "departure_airport_location", label: "AOD" },
            { value: "arrival_airport_location", label: "AOA" },
            { value: "destination", label: "Destination" }
            ];
    }

    let transhipment = ['ts1_port_location', 'ts2_port_location', 'ts3_port_location', 'ts4_port_location']
    let transhipmentAir = ['ts1_airport_location', 'ts2_airport_location', 'ts3_airport_location', 'ts4_airport_location']
    let reworkingType = ['reworking_pol_port_location', 'reworking_pod_port_location']
    if(ret.shipmentType === 'Air'){
        transhipmentAir.forEach((ele, index) => {
            if(ret[ele] !== undefined && ret[ele] !== "" && ret[ele] !== null) mileStoneArr.push({ value: ele, label: `Transhipment ${index+1}` }) 
        })
    }else{
        transhipment.forEach((ele, index) => {
            if(ret[ele] !== undefined && ret[ele] !== "" && ret[ele] !== null) mileStoneArr.push({ value: ele, label: `Transhipment ${index+1}` }) 
        })
    }
    reworkingType.forEach((ele, index) => {
        if(ret[ele] !== undefined && ret[ele] !== "" && ret[ele] !== null) mileStoneArr.push({ value: ele, label: `Reworking ${index === 0 ? 'POL' : 'POD'}` }) 
    })


    const exception = {
        optionSelected: '',
        milestoneSelected: '',
        isActive: true,
        updatedRemarks: [
            {
                remarks: "",
                notifyCustomer: true,
                email: false,
                pkey: [],
                fileLink: [],
            }
        ]
    }
    let updateForm = ret?.exceptionData?.map((item) => ({
        ...item,

        updatedRemarks: item.updatedRemarks
            ?.filter(
                (remark) =>
                    remark.remarks?.trim() !== "" || !remark.email
            ).map((remark) => ({
                ...remark,
                remarks: cleanRemarks(remark.remarks)
            }))
    }));
    let editRemarks = ret?.exceptionData?.map((item) => {
        if(!item.isActive){
            return true;
        }else{
            return item?.updatedRemarks ? item.updatedRemarks.at(-1).email  : item.email;
        }
    });
    const [errors, setErrors] = useState([]);
    const [exceptionStatus, setexceptionStatus] = useState('all')
    const [formData, setFormData] = useState(ret?.exceptionData && ret?.exceptionData?.length > 0  ? updateForm : [exception]);
    const [optionSelected, setSelected] = useState(ret?.exceptionData?.exceptionlist ? ret.exceptionData.exceptionlist : []);
    const [exceptionList, setException] = useState([]);
    const [edit, setEdit] = useState(ret?.exceptionData && ret?.exceptionData?.length > 0  ? editRemarks : [false]);
    const [showHistory, setShowHistory] = useState(ret?.exceptionData && ret?.exceptionData?.length > 0  ? ret?.exceptionData.map((ele) =>  ele.updatedRemarks?.length > 1 ? true : false) : [false]);
    useEffect(() => {
        if (!myactionsstore.exceptionModalVisible) return

        const exceptionData = configStore.modalvisibledata?.exceptionData
        const hasExceptions = Array.isArray(exceptionData) && exceptionData.length > 0
        const reopenedFormData = hasExceptions
            ? exceptionData.map((item) => ({
                ...item,
                updatedRemarks: item.updatedRemarks
                    ?.filter((remark) => remark.remarks?.trim() !== "" || !remark.email)
                    .map((remark) => ({
                        ...remark,
                        remarks: cleanRemarks(remark.remarks),
                    })),
            }))
            : [{
                optionSelected: '',
                milestoneSelected: '',
                isActive: true,
                updatedRemarks: [{
                    remarks: "",
                    notifyCustomer: true,
                    email: false,
                    pkey: [],
                    fileLink: [],
                }],
            }]

        setFormData(reopenedFormData)
        setEdit(hasExceptions
            ? exceptionData.map((item) => !item.isActive
                ? true
                : item.updatedRemarks ? item.updatedRemarks.at(-1).email : item.email)
            : [false])
        setShowHistory(hasExceptions
            ? exceptionData.map((item) => item.updatedRemarks?.length > 1)
            : [false])
        setSelected(exceptionData?.exceptionlist || [])
        setErrors([])
    }, [myactionsstore.exceptionModalVisible, configStore.modalvisibledata])
    const defaultException = [
  {
    label: "Delayed Arrival at CFS",
    value: "The shipment arrived at the container facility later than scheduled due to operational or transportation delays."
  },
  {
    label: "Export Clearance Issues",
    value: "Export customs clearance is delayed due to documentation or regulatory checks."
  },
  {
    label: "Container Roll-over by Carrier due to Load Count Restrictions",
    value: "The shipping line could not load the container on the planned vessel due to space limitations and has moved it to the next available vessel."
  },
  {
    label: "Rolled-over due to Less Inducement",
    value: "The shipping line moved the container to a later vessel due to commercial prioritization."
  },
  {
    label: "Import Clearance Issues",
    value: "Import customs clearance is delayed due to documentation review or regulatory requirements at destination."
  },
  {
    label: "Pick-up by Transporter Delayed",
    value: "Cargo pickup has been delayed due to transporter availability or operational constraints."
  },
  {
    label: "Pending for Appointment with Amazon",
    value: "Delivery is pending as an appointment with the Amazon fulfillment center is required before delivery."
  },
  {
    label: "Pending for Appointment with Consignee",
    value: "Delivery is on hold as the consignee has not yet confirmed a delivery appointment."
  },
  {
    label: "Incorrect Delivery Information Provided and On-hold for Approvals",
    value: "Delivery is on hold due to incorrect or missing delivery details and is awaiting approval to proceed."
  }
];

    const fetchFields = async () => {
        try {
            const url = `${process.env.REACT_APP_API_SERVER}/api/v1/common/visibility/exceptions`;
            const response = await MonApi.apost(url, {});

            if (response && response.allFields) {
                response.allFields.map((ele) => defaultException.push({label: ele.Exception, value:ele.Description}));
                let exceptionData = defaultException.map(ele => ({label: ele.label, value: ele.value}))
                exceptionData = [...exceptionData, {value: "", label: "", isDisabled: true}]
                setException(exceptionData);
            }else{
                setException(defaultException.map(ele => ({
                    value: ele.value,
                    label: ele.item
                })));
            }
        } catch (error) {
            console.error("Error fetching fields:", error);
        }
    };
    
    useEffect(() =>{
        fetchFields()
    }, [])

    const updateRow = (index, key, value) => {
        setFormData((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, [key]: key === 'isActive' ? 
            value.label === 'Closed' ? false : true : value } : item
          )
        );
    };

    const getRemarksValue = (ele) => {
        if (Array.isArray(ele.updatedRemarks)) {
            const currentUpdate = ele.updatedRemarks.find(
                (remark) => remark.email === false
            );

            if (currentUpdate) {
                return currentUpdate.remarks || "";
            }
        }

        return ele.remarks || "";
    };
    const handleRemarks = (index, key, value) => {
        setFormData((prev) => {
            const currentItem = prev[index];
            if (!currentItem) return prev;

            const updateIndex = currentItem.updatedRemarks?.findIndex(
                (remark) => remark.email === false
            );

            if (updateIndex === undefined || updateIndex === -1) {
                if (currentItem[key] === value) {
                    return prev;
                }
                return prev.map((item, itemIndex) =>
                    itemIndex === index ? { ...item, [key]: value } : item
                );
            }

            if (currentItem.updatedRemarks[updateIndex]?.[key] === value) {
                return prev;
            }

            return prev.map((item, itemIndex) => {
                if (itemIndex !== index) return item;
                const updatedRemarks = [...item.updatedRemarks];
                updatedRemarks[updateIndex] = {
                    ...updatedRemarks[updateIndex],
                    [key]: value,
                };
                return {
                    ...item,
                    updatedRemarks,
                };
            });
        });
    };

    // const handleRemarks = (index, value) => {
    //     setFormData((prev) =>
    //         prev.map((item, itemIndex) => {
    //             if (itemIndex !== index) return item;
    //             console.log("item------->", item.updatedRemarks)
    //             if(item.updatedRemarks){
    //                 return {
    //                     ...item,
    //                     updatedRemarks: item?.updatedRemarks.map((remark) =>
    //                         remark.email === false
    //                             ? {
    //                                 ...remark,
    //                                 remarks: value,
    //                             }
    //                         : remark
    //                     ),
    //                 };
    //             }else{
    //                 return item;
    //             }
                
    //         })
    //     );
    // };

    const handleRemove = (docIndex, rowIndex = 0, updateIndex = 0) => {
        setFormData((prev) =>
            prev.map((item, i) => {
            if (i !== rowIndex) return item;

            return {
                ...item,
                updatedRemarks: item.updatedRemarks.map((update, j) => {
                if (j !== updateIndex) return update;

                return {
                    ...update,
                    pkey: update.pkey.filter(
                    (_, index) => index !== docIndex
                    ),
                    fileLink: update.fileLink.filter(
                    (_, index) => index !== docIndex
                    ),
                };
                }),
            };
            })
        );
    };

    function hasDuplicate(data) {
        let seen = new Set();
        return data.filter((ele) => ele.isActive).some(item => {
            let key = `${item.optionSelected.value}|${item.milestoneSelected.value}`;
            if (seen.has(key)) {
                return true;
            }
            seen.add(key);
            return false;
        });
    }
      
    function checkValidation() {
        const isRemarkEmpty = (html) => {
            const text = html
                ?.replace(/<[^>]*>/g, "")
                .replace(/&nbsp;/g, " ")
                .trim();

            return !text;
        };

        const newErrors = formData.map((ele) => {
            const editableRemark = ele.updatedRemarks
                ?.slice()
                .reverse()
                .find((remark) => remark?.email === false);

            return {
                optionSelected: !ele.optionSelected,
                milestoneSelected: !ele.milestoneSelected,
                remarks: editableRemark ? isRemarkEmpty(editableRemark.remarks) : false
            };
        });
        setErrors(newErrors);
        console.log("formData.........", formData)
        if(hasDuplicate(formData)){
            configStore.setModalMessage("Same ExceptionType and Milestone Not Allowed") 
        }else if(newErrors.every((err) => !err.optionSelected && !err.milestoneSelected && !err.remarks )){
            return true
        }else{
            configStore.setModalMessage("Please Check the Fields") 
        }
    }

    function updateFile(files, label, key, index) {
        const formfileData = new FormData();
        formfileData.append("myFile", files);
        formfileData.append("label", label);
        formfileData.append("key", key);
        fetch(`${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`, {
          method: "POST",
          headers: Api.H1(),
          credentials: Utils.shouldSendCredentials(process.env.REACT_APP_FILE_SERVER) ? 'include' : 'omit',
          body: formfileData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
                configStore.setModalMessage(data.error);
                return;
            }

            setFormData((prev) =>
                prev.map((item, i) => {
                    if (i !== index) return item;
                    return {
                        ...item,
                        updatedRemarks: item.updatedRemarks.map((remark) => {
                            if (remark.email !== false) return remark;
                            const pkeys = remark.pkey || [];
                            const files = remark.fileLink || [];
                            if (files.length >= 5) {
                                configStore.setModalMessage("You can upload a maximum of 5 files.");
                                return remark;
                            }
                            return {
                                ...remark,
                                pkey: [...pkeys, data.key.pkey],
                                fileLink: [...files, data.key.filename],
                            };
                        }),
                    };
                })
            );
          })
          .catch((error) => {
            console.error("error on updateFile:", error);
          });
    }

    const onsubmit = () => {
    
        if(checkValidation()){
            let li = Object.keys(ret)
            let lvs = {}
            for (let i = 0; i < li.length; i++) {
                lvs[li[i]] = ret[li[i]]
            }
            let exceptionlistArr = [];
            optionSelected.map((ele) => exceptionlistArr.push(ele));
            lvs.exceptionData = formData.map((item) => ({
                ...item,
                updatedRemarks: item.updatedRemarks?.map((remark) => ({
                    ...remark,
                    remarks: cleanRemarks(remark.remarks)
                }))
            }));
            configStore.modalvisibledata = lvs;
            myactionsstore.exceptionModalVisible = false;
        }
        
    };

    function cleanRemarks(html) {
        if (typeof html !== "string") return html;

        let result = html
            .replace(/<span class="ql-cursor">.*?<\/span>/gi, "")
            .replace(/[\uFEFF]/g, "")
            .replace(/>\s*\n+\s*</g, "><")
            .trim();

        const textContent = result.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
        if (!textContent) return "";

        // Remove leading and trailing empty paragraphs
        result = result
            .replace(/^(?:\s*<p>(?:<br\s*\/?>|&nbsp;|\s)*<\/p>)+/gi, "")
            .replace(/(?:<p>(?:<br\s*\/?>|&nbsp;|\s)*<\/p>\s*)+$/gi, "");

        // Trim leading and trailing whitespace inside tags
        result = result
            .replace(/(<[a-z][\w-]*(?:\s[^>]*)?>)[ \t]+/gi, "$1")
            .replace(/[ \t]+(<\/[a-z][\w-]*>)/gi, "$1");

        return result.trim();
    }



    let modalClass = 'modal'
    if (myactionsstore.exceptionModalVisible) modalClass += ' is-active';
    console.log("exception---------->", formData, edit,  errors)
    return(
        <>  
            { myactionsstore.exceptionModalVisible && formData  ?
                <div class={modalClass} >
                    <div className="modal-background" ></div>
                    <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{overflow: 'auto', borderRadius: '10px',width:"75rem"}} >
                        <section className="p-8 modal-card-body" style={{overflow: formData.length >= 4 ? 'scroll' : 'visible', width: "70em",borderRadius:"7px",display: 'flex', 
                            flexDirection: 'column', margin: 'auto', height: formData.length >= 4 ? '425px' : ''}} >
                            
                            <div style={{display: 'flex', justifyContent: 'space-between'  }}>
                                <h1 class="mb-3 text-xl font-semibold">Exception and Alerts</h1>
                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <label style={{ fontWeight: "600" }}>Select Status:</label>
                                    <select
                                        value={exceptionStatus}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setexceptionStatus(e.target.value)
                                            if (value === "all") {
                                                setFormData(ret?.exceptionData?.length > 0 ? updateForm : [{ ...exception }]);
                                            }
                                            if(value === 'open'){
                                                setFormData(updateForm?.filter(ele => ele.isActive === true));
                                            }
                                            if(value === 'close'){
                                                setFormData(updateForm?.filter(ele => ele.isActive === false))
                                            }
                                        }}
                                        style={{
                                        padding: "5px 10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                        marginLeft: "6px",
                                        }}
                                        >
                                        <option value="all">All</option>
                                        <option value="open">Open</option>
                                        <option value="close">Close</option>
                                    </select>
                                </div>
                                
                                </div>
                            {formData.length > 0 ? formData.map((ele, index) => {
                            return (
                                <div key={ele._id || `exception-item-${index}`}>
                                    <div style={{display: '',padding: '5px 10px', marginBottom: '15px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', borderRadius: '5px' }}>
                                        <ul class={ele.open ? "flex mt-2 mb-3" : "is-hidden"}>
                                            { ele?.open && <li style={{padding: '3px 10px', borderRadius: '18px', height: '24px', fontSize: '12px', background:'#F1F2FF', color: '#484F9A'}} >&bull; Open Date: {new Date(ele.open).toISOString().split("T")[0]}</li>}
                                            { ele?.open && <li style={{margin: '0px 15px', padding: '3px 10px', borderRadius: '18px', height: '24px', fontSize: '12px', background:'#fcf0de', color: '#f3b04d'}} >&bull; Opened By: {ele.openBy}</li>}
                                            { ele?.closed && <>|</>}
                                            { ele?.closed && <li style={{margin: '0px 15px', padding: '3px 10px', borderRadius: '18px', height: '24px', fontSize: '12px', background:'#F1F2FF', color: '#484F9A'}} >&bull; Close Date: {new Date(ele.closed).toISOString().split("T")[0]}</li>}
                                            { ele?.closed && <li style={{padding: '3px 10px', borderRadius: '18px', height: '24px', fontSize: '12px', background:'#fcf0de', color: '#f3b04d'}} >&bull; Closed By: {ele.closedBy}</li>}
                                            { ele?.updatedRemarks?.filter((e) => e.email).slice(1).length > 0 && 
                                                <button type="button" onClick={() =>
                                                    setShowHistory((prev) =>
                                                        prev.map((value, i) => (i === index ? !value : value))
                                                    )
                                                    } className="inline-flex ml-auto mr-4 items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-blue-600 border-none bg-[#F1F2FF] border-blue-600 rounded-md">
                                                    ↻ Show history
                                                </button>
                                            }
                                        </ul>
                                        
                                        <div class='flex mt-2 mb-2' key={index+1}>
                                            <Select 
                                                options={exceptionList}
                                                isDisabled={ele?.open}
                                                onChange={(selected) => updateRow(index, "optionSelected", selected)}
                                                value={ele.optionSelected}
                                                isSelectAll={true}
                                                menuPlacement={"bottom"}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        marginRight: '10px',
                                                        width: '210px',
                                                        borderColor: errors[index]?.optionSelected ? "red" : provided.borderColor
                                                    }),
                                                }}
                                                placeholder={'Select Excetion Type'}
                                                maxMenuHeight={200}
                                            />
                                            <Select 
                                                options={mileStoneArr}
                                                isDisabled={ele?.open} 
                                                onChange={(selected) => updateRow(index, "milestoneSelected", selected)}
                                                value={ele.milestoneSelected}
                                                isSelectAll={true}
                                                menuPlacement={"bottom"}
                                                styles={{
                                                control: (provided) => ({
                                                        ...provided,
                                                        marginRight: '10px',
                                                        width: '150px',
                                                        borderColor: errors[index]?.milestoneSelected ? "red" : provided.borderColor
                                                    }),
                                                }}
                                                placeholder={'MileStone'}
                                                maxMenuHeight={200}
                                            />
                                            <ReactQuill
                                                key={`quill-${index}-${edit[index] ? 'readonly' : 'editable'}`}
                                                readOnly={edit[index]}
                                                value={
                                                    (edit[index]
                                                        ? ele?.updatedRemarks?.at(-1)?.remarks || ele?.remarks
                                                        : ele?.updatedRemarks?.find((remark) => !remark.email)?.remarks || ele?.remarks) || ""
                                                }
                                                onChange={(value, delta, source) => {
                                                    if (!edit[index] && source === 'user') {
                                                        handleRemarks(index, 'remarks', value);
                                                    }
                                                }}
                                                modules={QUILL_MODULES}
                                                placeholder="Enter exception remarks..."
                                                className={`${errors[index]?.remarks ? "has-error" : ""}`}
                                                style={{ 
                                                    width: "230px",
                                                    height: "38px",
                                                    overflow: "hidden",
                                                    padding: "0px",
                                                    marginRight: '10px',
                                                    fontSize: "16px",
                                                }} 
                                            />
                                            <Select 
                                                isDisabled={!ele.isActive && !ret.exceptionData[index]?.isActive}
                                                options={[{ value: "Open", label: "Open" }, { value: "Closed", label: "Closed", isDisabled: !edit[index]}]}
                                                defaultValue={status.filter((sts) => ele.isActive ? sts.label === 'Open' : sts.label === 'Closed')}
                                                onChange={(selected) => updateRow(index, "isActive", selected)}
                                                value={status.filter((sts) => ele.isActive ? sts.label === 'Open' : sts.label === 'Closed')}
                                                isSelectAll={true}
                                                menuPlacement={"bottom"}
                                                styles={{
                                                control: (provided) => ({
                                                        ...provided,
                                                        marginRight: '10px',
                                                        width: '110px',
                                                    }),
                                                }}
                                                maxMenuHeight={150}
                                            />
                                            <div class="flex items-center space-x-2">
                                                <input
                                                    disabled={edit[index]}
                                                    type="checkbox"
                                                    id="notifyCustomer"
                                                    checked={
                                                    edit[index] ? ele?.updatedRemarks?.at(-1)?.notifyCustomer 
                                                        | ele?.notifyCustomer : ele?.updatedRemarks?.find((remark) => !remark.email)?.notifyCustomer
                                                    }
                                                    onChange={(e) => handleRemarks(index, 'notifyCustomer', e.target.checked)}
                                                    class="text-green-600"
                                                />
                                                <label htmlFor={`notifyCustomer-${index}`} className="font-medium ml-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Notify Customer</label>
                                            </div>
                                            {!myactionsstore.exceptionModalDisable && (
                                                <>
                                                    {ele?.updatedRemarks?.find((remark) => remark.email === false) ? (
                                                <div class= 'flex items-center mx-2'>
                                                    <label htmlFor={`fileInput-${index+1}`} className="cursor-pointer">
                                                        <i
                                                            class="fa-solid fa-file-arrow-up is-clickable"
                                                            style={{ 
                                                                fontSize:'28px'
                                                            }}
                                                        />
                                                    </label>
                                                    <input
                                                        style={{ display: 'none' }}
                                                        id={`fileInput-${index+1}`}
                                                        type="file"
                                                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                                                        onChange={(e) => {
                                                            console.log("onChange", !e.target.files[0])
                                                            if(!e.target.files[0]) return
                                                            const maxSize = 5 * 1024 * 1024;
                                                            const allowedTypes = [
                                                            'image/jpeg',
                                                            'image/png',
                                                            'application/pdf',
                                                            ];
                                                        
                                                            if (!allowedTypes.includes(e.target.files[0].type)) {
                                                                configStore.setModalMessage('Invalid file type. Only images or PDFs are allowed.')
                                                                e.target.value = "";
                                                                return
                                                            }
                                                            
                                                            if (e.target.files[0].size > maxSize) {
                                                                configStore.setModalMessage("File size exceeds 5MB limit.")
                                                                e.target.value = "";
                                                                return
                                                            }

                                                            if(!ele.optionSelected.value){
                                                                configStore.setModalMessage("Please select Exception type")
                                                                e.target.value = "";
                                                                return
                                                            }
                                                            updateFile(e.target.files[0], 'Exception',  ele.optionSelected.value, index)
                                                        }}
                                                    />
                                                </div>
                                                    ) : null}

                                            {
                                                ele.fileLink && ele?.fileLink !== "" ? (
                                                <div className="flex align-center justiify-center">
                                                    <span class='icon mt-1 ml-3 is-size-4 '>
                                                        <span className="ml-2 mr-1">
                                                            <a
                                                                href={
                                                                process.env.REACT_APP_FILE_SERVER +
                                                                "/api/v1/filestore/getfile/" +
                                                                ele?.pkey +
                                                                "/" +
                                                                ele?.fileLink
                                                                }
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                alt="">
                                                                <BsFillEyeFill />
                                                            </a>
                                                        </span>
                                                        
                                                    </span>
                                                    {
                                                        !ele.email ? (
                                                            <span class='icon mt-1 ml-3 is-size-4'>
                                                                <span style={{ cursor: "pointer"}}>
                                                                    <MdDelete
                                                                        onClick={() => setFormData((prev) => prev.map((item, i) => i === index ? 
                                                                            {...item, pkey: '', fileLink: ''} : item ))
                                                                        }
                                                                    />
                                                                </span>
                                                            </span>
                                                        ): null}
                                                </div>
                                                ): null}
                                                </>
                                            )}
                                            <div>
                                                {
                                                    formData.length - 1 === index && exceptionStatus === 'all' && !myactionsstore.exceptionModalDisable ? 
                                                    <button type="button" className="ml-2 is-small button is-success is-inverted is-hovered is-active"
                                                        onClick={() => {
                                                            setFormData((prev) => [...prev, { ...exception }])
                                                            setEdit((prev, i) => [...prev, false])
                                                        }}>
                                                        <span className="icon is-small">
                                                            <i className="fas fa-plus"></i>
                                                        </span>
                                                    </button> : <></>
                                                }
                                                {
                                                    formData.length > 1 && exceptionStatus === 'all' && !myactionsstore.exceptionModalDisable ? 
                                                    <button type="button" className="ml-2 is-small button is-danger is-inverted is-hovered is-active"
                                                    onClick={() => {
                                                        setEdit((prev) => prev.filter((_, i) => i !== index)                                                        );
                                                        setFormData((prev) => prev.filter((_, i) => i !== index));
                                                    }}>
                                                    <span className="icon is-small">
                                                        <i className="fas fa-trash"></i>
                                                    </span>
                                                </button> : <></>
                                                }
                                                { ele?.open && ele.closed === undefined && edit[index] && exceptionStatus === 'all' && !myactionsstore.exceptionModalDisable ? (
                                                    <button type="button"
                                                        className="ml-2 is-small button is-info is-inverted is-hovered is-active"
                                                        onClick={() => {
                                                            setEdit((prev) => {
                                                                const updated = [...prev];
                                                                updated[index] = false;
                                                                return updated;
                                                            });
                                                            setFormData(
                                                                formData.map((editEle, editIndex) => {
                                                                if(editIndex === index){
                                                                    if (editEle?.updatedRemarks) {  
                                                                        return {
                                                                            ...editEle,
                                                                            updatedRemarks: [
                                                                                ...editEle.updatedRemarks,
                                                                                {
                                                                                    remarks: "",
                                                                                    email: false,
                                                                                    notifyCustomer: true,
                                                                                    pkey: [],
                                                                                    fileLink: [],
                                                                                }
                                                                            ],
                                                                        };
                                                                    }else{
                                                                        return {
                                                                            optionSelected: editEle.optionSelected,
                                                                            milestoneSelected: editEle.milestoneSelected,
                                                                            isActive: editEle.isActive,
                                                                            open: editEle.open,
                                                                            openBy: editEle.openBy,
                                                                            updatedRemarks: [
                                                                                {
                                                                                    remarks: editEle.remarks,
                                                                                    email: editEle.email,
                                                                                    notifyCustomer: editEle.notifyCustomer,
                                                                                    pkey: editEle.pkey !== '' ? [editEle.pkey] : [],
                                                                                    fileLink: editEle.fileLink !== '' ? [editEle.fileLink] : [],
                                                                                    updated: editEle.open !== '' ? editEle.open : '',
                                                                                    updatedBy: editEle.openBy !== '' ? editEle.openBy : '',
                                                                                },
                                                                                {
                                                                                    remarks: "",
                                                                                    email: false,
                                                                                    notifyCustomer: true,
                                                                                    pkey: [],
                                                                                    fileLink: [],
                                                                                }
                                                                            ],
                                                                        };
                                                                    }
                                                                }else{
                                                                    return editEle;
                                                                }
                                                            })
                                                            )
                                                        }}
                                                    >
                                                        <span className="icon is-small">
                                                        <i className="fas fa-edit"></i>
                                                        </span>
                                                    </button>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap items-center gap-2 mt-1">
                                            {(() => {
                                                const updateIndex = ele.updatedRemarks?.length - 1;
                                                const update = ele.updatedRemarks?.[updateIndex];

                                                return update?.fileLink?.map((file, docIndex) => {
                                                    const pkey = update.pkey?.[docIndex];

                                                    return (
                                                        <div
                                                            key={`${updateIndex}-${docIndex}`}
                                                            className="inline-flex h-10 items-center gap-2 rounded-md bg-[#E8EEFF] px-2.5 text-sm text-gray-700"
                                                        >
                                                            <span className="max-w-[130px] truncate whitespace-nowrap">
                                                                {file}
                                                            </span>
                                                            {pkey && file && (
                                                                <a
                                                                    href={
                                                                        `${process.env.REACT_APP_FILE_SERVER}` +
                                                                        `/api/v1/filestore/getfile/` +
                                                                        `${encodeURIComponent(pkey)}/` +
                                                                        `${encodeURIComponent(file)}`
                                                                    }
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    title="View document"
                                                                    className="d-flex text-gray-600 hover:text-blue-600 text-xl"
                                                                >
                                                                    <BsFillEyeFill />
                                                                </a>
                                                            )}
                                                            { (!update.email || ele?.open === undefined) && <button
                                                                type="button"
                                                                className="flex h-7 w-7 items-center justify-center border-none bg-[#E8EEFF] text-lg text-red-500 hover:bg-red-100"
                                                                onClick={() =>
                                                                    handleRemove(
                                                                        docIndex,
                                                                        index,
                                                                        updateIndex
                                                                    )
                                                                }
                                                            >
                                                                ×
                                                            </button>}
                                                        </div>
                                                    );
                                                });
                                            })()}
                                        </div>
                                        
                                        <div className="space-y-3 my-2">
                                            { !showHistory[index] && ele?.updatedRemarks?.filter((ele) => ele.email).length > 1 && 
                                                ele?.updatedRemarks?.filter((ele) => ele.email).reverse().slice(1)
                                                .map((update, updateIndex) => (
                                                    <div
                                                        key={updateIndex}
                                                        style={{boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'}}
                                                        className="border-b border-gray-200 px-4 py-3"
                                                    >
                                                        <div className="mb-2 flex items-center justify-between text-xs font-semibold text-gray-600">
                                                            <span>
                                                                {`Update Date/Time: ${update.updated ? new Date(update.updated)
                                                                        .toLocaleString("en-GB", {
                                                                            day: "2-digit",
                                                                            month: "2-digit",
                                                                            year: "numeric",
                                                                            hour: "2-digit",
                                                                            minute: "2-digit",
                                                                            hour12: false
                                                                        })
                                                                        .replace(",", "") : 'NA'}`}
                                                            </span>
                                                            <span>
                                                                {`Update By: ${update.updatedBy ? update.updatedBy : 'NA'}`}
                                                            </span>
                                                        </div>
                                                        <div className="mb-2 grid grid-cols-5 gap-2">
                                                            {update.fileLink?.map((file, docIndex) => {
                                                                const pkey = update.pkey?.[docIndex];

                                                                if (!file || !pkey) return null;

                                                                const fileUrl =
                                                                    `${process.env.REACT_APP_FILE_SERVER}` +
                                                                    `/api/v1/filestore/getfile/` +
                                                                    `${encodeURIComponent(pkey)}/` +
                                                                    `${encodeURIComponent(file)}`;

                                                                return (
                                                                    <a
                                                                        key={docIndex}
                                                                        href={fileUrl}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        className="inline-flex min-w-0 bg-[#E8EEFF] items-center gap-1 rounded-md border border-gray-200 bg-gray-50 px-3 py-1 text-xs font-medium text-blue-600 hover:bg-blue-50"
                                                                    >
                                                                        📄
                                                                        <span className="truncate">
                                                                            {file}
                                                                        </span>
                                                                    </a>
                                                                );
                                                            })}
                                                        </div>
                                                        <div className="rounded-md p-2 bg-red-50 bg-[#ffe1e7a3] text-red-400">
                                                            <div className='text-sm text-[#f14668]'
                                                                dangerouslySetInnerHTML={{
                                                                    __html: update.remarks || "-"
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            )}) : <div class='flex justify-center'>No Data</div>}
                            <div class="my-4 is-flex is-justify-content-end">
                                <button type="button" class="mr-5 button is-warning" onClick={() => {
                                    myactionsstore.exceptionModalVisible = false;
                                    setFormData([])
                                    setEdit([])
                                }} >cancel</button>                   
                                {
                                    !myactionsstore.exceptionModalDisable && 
                                    <button type="button" class="button is-danger" onClick={onsubmit}>Submit</button>
                                }
                            </div>
                        </section>
                    </div>
                </div>
            : <></> }
        </>
    )
}   